export const LEGALIDADE_REQUEST = "LEGALIDADE_REQUEST";
export const LEGALIDADE_SUCCESS = "LEGALIDADE_SUCCESS";
export const LEGALIDADE_FAIL = "LEGALIDADE_FAIL";
